const computedArr = function (arr, dept, handleDept) {
  for (let item of arr) {
    if (item.id === handleDept) {
      dept.deptName = item.name
    }
    if (item.children && item.children.length > 0) {
      computedArr(item.children, dept, handleDept)
    }
  }
}
const state = {
  status: 'NONE', // NONE ADD EDIT 分别对应列表，新增，编辑状态
  baseInfoFormInList: {}, // 主表基本信息
  tenderAccDetailList: [], // 表体信息列表
  accessoryInfo: [], // 附件信息列表
  handler: '', // 经办人
  handleDept: '', // 经办部门
  projectInfo: [], // 项目信息
  tenderAccDelIdList: [], // 要删除的表体id
  orgList: [], // 组织
  userOption: [], // 经办人列表
  deptData: [], // 经办部门列表
}

const mutations = {
  /**
   * 更新编辑状态
   */
  statusAccMt (state, newVal) {
    state.status = newVal
  },
  /**
   * 基本信息更新
   */
  baseInfoFormInListAccMt (state, newVal) {
    state.baseInfoFormInList = newVal
  },
  /**
   * 表体信息列表更新
   */
  tenderAccDetailListMt (state, newVal) {
    state.tenderAccDetailList = newVal
  },
  /**
   * 表体信息列表新增
   */
  tenderAccDetailListAdd (state, newVal) {
    state.tenderAccDetailList.push(newVal)
  },
  /**
   * 表体信息列表删除
   */
  tenderAccDetailListDel (state, index) {
    state.tenderAccDetailList.splice(index, 1)
  },
  /**
   * 附件信息列表更新
   */
  accessoryInfoAccMt (state, newVal) {
    state.accessoryInfo = newVal
  },
  /**
   * 经办人更新
   */
  handlerAccMt (state, newVal) {
    state.handler = newVal
  },
  /**
   * 经办部门更新
   */
  handleDeptAccMt (state, newVal) {
    state.handleDept = newVal
  },
  /**
   * 项目信息更新
   */
  projectInfoAccMt (state, newVal) {
    state.projectInfo = newVal
  },
  /**
   * 组织信息更新
   */
  orgListMt (state, newVal) {
    state.orgList = newVal
  },
  /**
   * 要删除的表体行
   * */
  tenderAccDelIdListMt (state, newVal) {
    state.tenderAccDelIdList = newVal
  },
  /**
   * 更新经办人列表
   * */
  userOptionMt (state, newVal) {
    state.userOption = newVal
  },
  /**
   * 更新经办部门列表
   * */
  deptDataMt (state, newVal) {
    state.deptData = newVal
  }
}

const actions = {
  handlerAccAct ({commit}, vm) { // actions中的函数作用域独立于vue
    const promise1 = new Promise(resolve => {
      vm.$http.post(vm.api.sysUserQueryById + sessionStorage.getItem('userId')).then(res => {
        if (res.data.code === '200') {
          commit('handlerAccMt', res.data.body.userName)
          resolve(res.data.body.userName)
        }
      })
    })
    const promise2 = new Promise(resolve => {
      vm.$http.get(vm.api.deptEdit + '/' + sessionStorage.getItem('deptId')).then(res => {
        if (res.data.code === '200') {
          commit('handleDeptAccMt', res.data.body.name)
          resolve(res.data.body.name)
        }
      })
    })
    return Promise.all([promise1, promise2])
  },
  handleUserInfo ({commit}, vm) {
    //获取用户下拉列表数据
    vm.$http.get(vm.api.queryAllUser).then(res => {
      if (res.data.code === "200") {
        commit('userOptionMt', res.data.body)
      } else {
        vm.$message.warning(res.data.body);
      }
    });
    //获取部门下拉列表数据
    vm.$http.post(vm.api.deptTree).then(res => {
      if (res.data.code === "200") {
        commit('deptDataMt', res.data.body)
      } else {
        vm.$message.warning(res.data.body);
      }
    });
  }
}

const getters = {
  getHandleName: ({userOption}) => handler => {
    for (let item of userOption) {
      if (item.id === handler) {
        return item.userName
      }
    }
  },
  getHandleDept: ({deptData}) => handleDept => {
    let dept = {
      deptName: ''
    }
    for (let item of deptData) {
      if (item.id === handleDept) {
        return item.name
      }
      if (item.children && item.children.length > 0) {
        computedArr(item.children, dept, handleDept)
      }
    }
    return dept.deptName
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/tenderAcc.js